/**
 * CookieAuth - Constants, cookie config, and types
 */

export const AUTH_COOKIE_NAME = 'quotech_auth'
export const REFRESH_COOKIE_NAME = 'quotech_refresh'
export const ORG_COOKIE_NAME = 'quotech_org'
export const INTEGRATIONS_COOKIE_NAME = 'quotech_integrations'
export const SESSION_COOKIE_NAME = 'quotech_session'
export const REMEMBER_ME_COOKIE_NAME = 'quotech_remember_me'

// Master login URL - all session expirations redirect here
export const MASTER_LOGIN_URL = typeof import.meta !== 'undefined' && import.meta.env?.DEV
  ? 'http://localhost:5174'
  : 'https://dashboard.quotech.ai'

// Shared domain for production; empty for localhost
export const AUTH_DOMAIN = typeof window !== 'undefined' && window.location.hostname.includes('quotech.ai')
  ? '.quotech.ai'
  : ''

export const IS_SECURE = typeof window !== 'undefined' && window.location.protocol === 'https:'

/** Integration status for the current organisation */
export interface IntegrationStatus {
  xero_connected: boolean
  xero_tenant_name: string | null
  xero_expires_at: string | null
  simpro_connected: boolean
  simpro_company_id: string | null
  onedrive_connected: boolean
  email_connected: boolean
  last_sync: string
}

/** Session metadata for tracking and multi-device management */
export interface SessionMetadata {
  login_time: string
  last_activity: string
  device_id: string
  hub_origin: string
}

export type LogoutReason = 'session_expired' | 'logged_out' | 'invalid' | 'inactivity'
